/** @jsxImportSource @emotion/react */

import React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
}

function InfoIcon(props: IProps) {
  const { width = 14, height = 14, ...rest } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g clipPath="url(#clip0_17342_1553)">
        <path
          d="M6.99984 12.8346C10.2215 12.8346 12.8332 10.223 12.8332 7.0013C12.8332 3.77964 10.2215 1.16797 6.99984 1.16797C3.77818 1.16797 1.1665 3.77964 1.1665 7.0013C1.1665 10.223 3.77818 12.8346 6.99984 12.8346Z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M7 9.33333V7" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 4.66797H7.005" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  );
}

export default InfoIcon;
